import React from 'react';

/**
 * @typedef {import('./AuthService').default} AuthService
 * @type {React.Context<AuthService>}
 */
export const AuthContext = React.createContext(null);
